import { useMemo } from 'react';
import { createAppDefaults } from '@eventbrite/bsp-sdk';
import type { BspSdkConfig, BspEnvironment } from '@eventbrite/bsp-sdk';
import { Stage } from '@eventbrite/webapp-constants';

// creator-collections-listing has no experiment/remote-settings needs today; an
// empty settings object keeps useBspConfig() the same shape the other apps use
// (covid-19-webapp's lib/bsp-config.ts, trending-webapp's lib/bsp-config.ts)
// without inventing unused flags.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type CreatorCollectionsSettings = {};

const DEFAULT_SETTINGS = createAppDefaults<CreatorCollectionsSettings>({});

// Map the CDK-injected Stage (Local/Dev/Test/Prod — see cdk/bin/cdk.ts) to
// bsp-sdk's BspEnvironment. Deliberately NOT hostname-sniffing (covid-19-webapp,
// Bugbot PR #89): STAGE is server-injected and authoritative, so use it instead
// of re-deriving environment from a client-side domain string.
const environmentForStage = (stage: Stage): BspEnvironment => {
    switch (stage) {
        case Stage.PROD:
            return 'production';
        case Stage.TEST:
            return 'staging';
        case Stage.DEV:
        case Stage.LOCAL:
        default:
            return 'development';
    }
};

export const useBspConfig = (
    stage: Stage,
): BspSdkConfig<CreatorCollectionsSettings> =>
    useMemo(
        () => ({
            appName: 'creator-collections-listing-webapp',
            environment: environmentForStage(stage),
            defaultOrionSettings: DEFAULT_SETTINGS,
            defaultSegmentations: {},
        }),
        [stage],
    );
